import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerSelect: {
    flex: 1,
    marginHorizontal: 4,
    borderRadius: 12,
  },
  textError: {
    color: '#f00',
    fontSize: 14,
    fontFamily: 'Arial',
  },

  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(52, 52, 52, 0.7)',
  },
  modalView: {
    width: '90%',
    backgroundColor: 'white',
    alignItems: 'center',
    marginVertical: 5,
    borderRadius: 4,
  },
  button: {
    paddingVertical: 20,
    width: '100%',
    // borderColor: 'rgba(224, 224, 224, 1)',
    // borderTopWidth: 1,
  },
  buttonOpen: {
    backgroundColor: '#F194FF',
  },
  buttonClose: {
    backgroundColor: '#2196F3',
  },
  textStyle: {
    color: 'black',
    paddingHorizontal: 10,
    fontSize: 15,
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
  itemPickerStyle: {
    borderWidth: 1,
    borderRadius: 30,
    backgroundColor: '#fff',
    paddingInline: 0,
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 16,
    marginTop: 5,
    fontSize: 14,
    paddingLeft: 25,
    paddingRight: 25,
  },
  selectBar: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    width: '100%',
    paddingLeft: 5,
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    borderRadius: 30,
    marginTop: 10,
  },
});
